<template>
  <el-card shadow="never">
    <div style="display: flex; justify-content: space-between;">
      <div class="ys-search-box">
        <el-form :inline="true" class="query_form" size="mini">
          <el-form-item label="仓库" prop="inWarehouse.selected">
            <select-multiple ref="inWarehouse" class="query_form_item" :select-data="Object.assign(queryForm.inWarehouse, { isDisabled: isCanEnter })" is-scroll
              :isClear="false" :change="inWarehouseSelect" suffixText="盘点中" @keydown.enter.right.native="inWarehouseSelect"></select-multiple>
          </el-form-item>
          <el-form-item label="盘点人" prop="deliverUser.selected">
            <select-multiple ref="deliverUser" class="query_form_item" :select-data="Object.assign(queryForm.deliverUser, { isDisabled: isCanEnter })" is-scroll
              :isClear="false" :change="deliverUserSelect" @keydown.enter.right.native="deliverUserSelect"
              @keydown.left.native="queryFormLeftOrRight($refs.deliverUser, $refs.inWarehouse)"></select-multiple>
          </el-form-item>
          <i class="el-icon-circle-plus-outline" style="font-size: 22px; color: #4075E6; cursor: pointer; margin: 4px 10px 0 0;" @click="isShowSalesman = true" v-if="!isCanEnter && !isShowSalesman"></i>
          <el-form-item label="协助盘点人" prop="salesman.selected" v-if="!isCanEnter && isShowSalesman">
            <select-multiple
              ref="salesman"
              class="query_form_item"
              :select-data="queryForm.salesman"
              is-scroll
              :change="salesmanSelect"
            ></select-multiple>
          </el-form-item>
          <el-form-item label="备注" prop="remark.selected">
            <el-input ref="remark" class="query_form_item" v-model.trim="queryForm.remark.selected"
              :placeholder="queryForm.remark.placeholder" @change="remarkChange" @keydown.enter.right.native="remarkChange"
              @keydown.left.native="queryFormLeftOrRight($refs.remark, $refs.deliverUser)" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-form :inline="true" class="query_form" size="mini">
        <el-form-item>
          <el-button type="primary" @click="toJump">订单占用查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-tooltip effect="light" placement="bottom">
            <div slot="content" class="tips">
              <span>整库盘空商品需要首先处理掉所有有库存占用的订单。</span>
            </div>
            <el-button type="warning" icon="el-icon-info" size="mini">提示</el-button>
          </el-tooltip>
        </el-form-item> -->
      </el-form>
    </div>
    <el-divider></el-divider>
    <div style="display: flex; justify-content: space-between;" class="last-form">
      <el-form :inline="true" class="query_form" size="mini">
        <template v-if="isCanEnter">
          <el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" @click="batchEnterInventory">批量录入</el-button>
            </el-form-item> -->
            <el-dropdown placement="bottom-start" @command="loadData">
              <el-button type="primary">
                加载数据<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="A">加载有库存商品</el-dropdown-item>
                <el-dropdown-item command="B">加载全部商品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item>
            <el-dropdown placement="bottom-start" @command="loadData">
              <el-button type="primary" plain>
                Excel导入<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="C">导入有库存商品</el-dropdown-item>
                <el-dropdown-item command="D">导入全部商品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item>
            <el-dropdown placement="bottom-start" @command="loadData">
              <el-button type="primary" plain>
                未填写盘点数<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="E">未填写盘点数设置为账面数</el-dropdown-item>
                <el-dropdown-item command="F">未填写盘点数设置为0</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </template>
        <el-form-item v-else>
            <el-tooltip effect="dark" content="开始盘点后库房状态为盘点中，无法进行入库和出库" placement="top">
                <el-button type="primary" @click="beginInventory">开始盘点</el-button>
            </el-tooltip>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="query_form" size="mini" @submit.native.prevent>
        <el-form-item v-if="indexList.length">
          <div style="color: #FF8940; font-size: 14px;">
            <span>商品在</span>
            <span v-for="(i, index) in indexList" :key="i" :style="[{ cursor: 'pointer' }, { color: activeIndex == i ? 'rgba(64, 158, 255, 0.6)' : '' }]" @click="tableScrollMove(i)">{{ i }}{{ indexList.length > (index + 1) ? '、' : '' }}</span>
            <span>行存在</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="输入商品名称或条码搜索" v-model="searchInput" clearable @keydown.enter.native="tableFilter">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button plain @click="tableFilter">定位</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :visible.sync="selectProductVisible" width="1080px" :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" @get-product-data="getProductData" :args="{ tag: 'PKD', warehouseID: queryForm.inWarehouse.selected.value }" :default-checked-keys="defaultCheckedKeys" :default-disabled-keys="defaultDisabledKeys"></selectProduct>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogImportVisible" width="400px">
      <template>
        <import-template
          :downloadTemplateURL="`/erpnew/account/c/reada46ceb/export/inventoryItem?warehouseID=${queryItem.warehouse.value}&searchType=${searchType}&optimize=Y&invCheckWay=C`"
          downloadTemplateName="盘点单导出模板"
          :isNew="true"
          type="financialBrand"
          @import-close="dialogImportColse"
          :importExcelURL="`/erpnew/account/c/reada46ceb/import/inventoryItem?warehouseID=${queryItem.warehouse.value}&searchType=${searchType}&optimize=Y&invCheckWay=C`"
        >
        </import-template>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import { getResultArray } from '@/assets/js/common.js'
import { queryFormLeftOrRight } from '@/assets/js/orderEntering.js'
import importTemplate from '@/components/common/importTemplate.vue'
import selectProduct from '../selectProduct.vue'
export default {
  props: {
    power: Object,
    billNo: String
  },
  components: {
    importTemplate,
    selectProduct
  },
  data() {
    return {
      queryForm: {
        salesman: {
          submitName: "salesman",
          selected: [],
          valueIsObj: true,
          isMultiple: true,
          isAll: false,
          isShowAll: false,
          isFilterable: true,
          isRemote: true,
          isPagination: true,
          isReSearch: false,
          list: [],
          placeholder: "请选择协助盘点人",
          request: {
            url: "/Account/userDefine/selectUserListForVue.html",
            type: "post",
            params: { page: 1, size: 10 },
            text: "",
            value: "",
          },
        },
        deliverUser: {
          submitName: "deliverUser",
          selected: {},
          valueIsObj: true,
          isMultiple: false,
          isAll: false,
          isShowAll: false,
          isFilterable: true,
          isRemote: true,
          isPagination: true,
          isReSearch: false,
          list: [],
          placeholder: "请选择盘点人",
          request: {
            url: "/Account/userDefine/selectUserListForVue.html",
            type: "post",
            params: { page: 1, size: 10 },
            text: "",
            value: "",
          },
        },
        inWarehouse: {
          submitName: "warehouse",
          selected: {},
          valueIsObj: true,
          isMultiple: false,
          isAll: false,
          isShowAll: false,
          isFilterable: true,
          isRemote: true,
          isPagination: true,
          isReSearch: false,
          isDisabled: false,
          list: [],
          placeholder: "请选择仓库",
          request: {
            url: "/Account/wareHouseDefine/selectWarehouseFreezeForAuth.html",
            type: "post",
            params: { page: 1, size: 10, billType: 'PKD' },
            text: "",
            value: "",
          },
        },
        remark: {
          submitName: "remark",
          selected: "",
          placeholder: "请输入备注",
        },
        id: {
          submitName: "id",
          selected: "",
        },
      },
      selectProductVisible: false,
      selectProductList: [],
      defaultCheckedKeys: [],
      defaultDisabledKeys: [],
      isCanEnter: false,
      searchInput: '',
      dialogImportVisible: false,
      searchType: '',
      indexList: [],
      activeIndex: -1,
      isShowSalesman: false
    };
  },
  created() { },
  mounted() {
    $(this.$refs.inWarehouse.$el).find('input').click(this.selectClick)
    console.log(this.billNo)
    if (this.billNo) return
    this.$refs.inWarehouse.$children[0].focus()
  },
  computed: {
    queryItem() {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        tempItem[item.submitName] = item.selected
      })
      return tempItem
    }
  },
  methods: {
    queryFormLeftOrRight(selfRef, nextOrPrevRef) {
      queryFormLeftOrRight(selfRef, nextOrPrevRef)
    },
    async inWarehouseSelect() {
      this.$emit('getQueryForm', this.queryItem)
      this.isCanEnter = false

      this.$nextTick(() => {
        this.$refs.inWarehouse.$children[0].blur()
        this.$refs.deliverUser.$children[0].focus()
        let $table = this.$parent.$children[1]
        $table.tableData = $table.pushItem()
        this.selectProductList = []
        this.defaultCheckedKeys = []
        this.$emit('resetCascaderMultiple')
      })
    },
    deliverUserSelect(val) {
      if (this.queryForm.salesman.selected && this.queryForm.salesman.selected.length) {
        let index = this.queryForm.salesman.selected.findIndex(i => i.value == val.value)
        if (index > -1) {
          this.$message({
            showClose: true,
            message: '协助盘点人不能与盘点人重复',
            type: 'warning'
          })
          this.$nextTick(() => {
            this.queryForm.deliverUser.selected = {}
            this.$emit('getQueryForm', this.queryItem)
          })
        } else {
          this.$emit('getQueryForm', this.queryItem)
          this.$nextTick(() => {
            this.$refs.deliverUser.$children[0].blur()
            this.$refs.remark.focus()
          })
        }
      } else {
        this.$emit('getQueryForm', this.queryItem)
        this.$nextTick(() => {
          this.$refs.deliverUser.$children[0].blur()
          this.$refs.remark.focus()
        })
      }
    },
    salesmanSelect(val) {
      let index = val.findIndex(i => i.value == this.queryItem.deliverUser.value)
      if (index > -1) {
        this.$message({
          showClose: true,
          message: '协助盘点人不能与盘点人重复',
          type: 'warning'
        })
        this.queryForm.salesman.selected = this.queryForm.salesman.selected.filter(i => i.value != val[index].value)
        this.$emit('getQueryForm', this.queryItem)
      } else {
        this.$emit('getQueryForm', this.queryItem)
      }
    },
    remarkChange() {
      try {
        this.$parent.$children[1].getProductData()
      } catch (error) {
        console.log(error);
      }
      this.$emit('getQueryForm', this.queryItem)
    },
    tableFilter() {
      this.$nextTick(() => {
        this.indexList = this.$parent.$children[1].tableFilter(this.searchInput)
        this.activeIndex = this.indexList[0]
      })
    },
    tableScrollMove(index) {
      this.activeIndex = index
      this.$parent.$children[1].tableScrollMove(index - 1)
    },
    toJump() {
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      top.addPanel('订单占用查询', `/templates/vue-account/dist/index.htm#/orderOccupy`, width, height, true)
      // this.$router.push('/orderOccupy')
    },
    selectClick() {
      this.$nextTick(async () => {
        if (this.$parent.$children[1].tableData.filter(i => i.itemID).length) {
          const confirmResult = await this.$confirm('您已录入商品，此操作将删除所以表格数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(err => err)
          if (confirmResult !== 'confirm') {
            this.$refs['inWarehouse'].$children[0].blur()
            return
          }
        }
      })
    },
    async beginInventory() {
      if (!this.queryItem.warehouse?.value) return this.$message({
        showClose: true,
        message: '请先选择仓库',
        type: 'warning'
      })
      if (!this.queryItem.deliverUser?.value) return this.$message({
        showClose: true,
        message: '请先选择盘点人',
        type: 'warning'
      })
      const loading = this.$loading({
        lock: true,
        text: '查询当前库房状态中, 请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
      let currTab = ''
      if (top.$('#tabspanel .tabs-selected').text()) {
        currTab = top.$('#tabspanel').tabs('getSelected') || ''
      } else {
        currTab = top.getTabName() || ''
      }
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/invCheck/startCheckList', {
        warehouseID: this.queryItem.warehouse.value,
        warehouseName: this.queryItem.warehouse.text,
        checkUserID: this.queryItem.deliverUser.value,
        checkUserName: this.queryItem.deliverUser.text,
        checkUserList: this.queryItem.salesman.map(i => ({ checkUserID: i.value, checkUserName: i.text })),
        remark: this.queryItem.remark,
        invCheckWay: 'C'
      })
      loading.close()
      if (res.code != 0) return this.$message({
        showClose: true,
        message: res.message,
        type: 'error'
      })
      top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm?v=${Math.random()}#/invCheckEntire?billNo=${res.data.billNo}&tag=edit`, currTab)
      this.isCanEnter = true
    },
    loadData(command) {
      if (!['E', 'F'].includes(command)) {
        this.$parent.$children[1].clearTable()
        this.selectProductList = []
      }
      if (command == 'A') {
        this.getProductAllData('A')
      } else if (command == 'B') {
        this.getProductAllData('B')
      } else if (command == 'C') {
        this.searchType = 'A'
        this.dialogImportVisible = true
      } else if (command == 'D') {
        this.searchType = 'B'
        this.dialogImportVisible = true
      } else if (command == 'E') {
        let $table = this.$parent.$children[1]
        this.$confirm('盘点数将设置为账面数, 请选择盘点状态', '操作确认', {
          distinguishCancelAndClose: true,
          confirmButtonText: '盘平',
          cancelButtonText: '未盘',
          type: 'warning'
        }).then(() => {
          $table.changeSalUnitQty(1)
        }).catch((action) => {
          if (action === 'cancel') {
            $table.changeSalUnitQty(0)
          }
        });
        
      } else if (command == 'F') {
        let $table = this.$parent.$children[1]
        this.$confirm('盘点数将设置为0', '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          $table.changeSalUnitQty(2)
        }).catch(() => {
          
        });
      }
    },
    getProductAllData(searchType) {
      this.$nextTick(async () => {
        let $table = this.$parent.$children[1]
        $table.tableLoading = true
        const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/select/inventoryItem', {
          warehouseID: this.queryForm.inWarehouse.selected.value,
          searchType,
          optimize: 'Y',
          invCheckWay: 'C'
        })
        if (res.code != "0") return this.$message.error(res.message);
        const result = await $table.addProductToOrder(res.data)
        this.selectProductList = res.data
        $table.computedInventory()
        if (result) $table.tableLoading = false
      })
    },
    async dialogImportColse({ data, type }) {
      this.dialogImportVisible = false
      if (type == 1) {
        let $table = this.$parent.$children[1]
        $table.tableLoading = true
        const result = await $table.addProductToOrder(data.resultList)
        this.selectProductList = data.resultList
        $table.computedInventory()
        if (result) $table.tableLoading = false
      }
      console.log(data);
    },
    batchEnterInventory() {
      if (!this.queryForm.inWarehouse.selected.value) return this.$message({
        showClose: true,
        message: '请先选择仓库',
        type: 'warning'
      })
      if (!this.isCanEnter) return this.$message({
        showClose: true,
        message: '请先点击开始盘点按钮',
        type: 'warning'
      })
      this.selectProductVisible = true
      this.defaultCheckedKeys = this.$parent.$children[1]?.tableData?.filter(i => Boolean(i.itemID)).map(i => {
        i['text'] = i['itemName']
        i['value'] = i['itemID']
        return i
      })
    },
    async getProductData(data) {
      this.selectProductVisible = false
      let $table = this.$parent.$children[1]
      const keys = (i) => {
        return i.itemID + i.productionDate
      }
      $table.tableLoading = true
      let add = getResultArray(keys, 'd', data, this.selectProductList)
      let detele = getResultArray(keys, 'd', this.selectProductList, data)
      console.log({ add, detele })
      if (add.length) {
        this.selectProductList = this.selectProductList.concat(add)
        const res = await $table.addProductToOrder(add)
        if (res) $table.tableLoading = false
      }
      if (detele.length) {
        detele.forEach(item => {
          this.selectProductList = this.selectProductList.filter(i => keys(i) != keys(item))
        })
        const res = await $table.deleteProductToOrder('', '', detele)
        if (res) $table.tableLoading = false
      }
      if (add.length == 0 && detele.length == 0) {
        $table.tableLoading = false
      }
    },
  },
};
</script>

<style scoped lang="less">


.el-divider {
  margin: 0 0 12px 0;
}
.last-form {
  ::v-deep .el-form-item {
    margin-bottom: 0 !important;
  }
}
.tips {
  display: flex;
  flex-flow: column;
  font-size: 16px;
  color: #F56C6C;
  span:not(:nth-child(1)) {
    margin-top: 6px;
  }
  
}
</style>
